import React, { useContext } from "react";
import moment from "moment";
import { translate } from "../../../utility/strings.js";

import { ShipmentContext } from "../../contexts/ShipmentContext.jsx";

const ShipmentSummary = () => {

  let { shipment, loading } = useContext(ShipmentContext);
  
  if(loading){
    const skeleton = <div className="shipment-summary container container--narrow my-10 flex justify-between gap-5">
      <div className="shipment-summary__item text-center">
        <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">{translate("shipment_tracking.picked_up", "Picked Up:")}</animate><br/>
        <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Loading...</animate>
      </div>
      <div className="shipment-summary__item text-center">
        <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">{shipment?.summary?.actual_delivery ? translate("shipment_tracking.actual_delivery", "Delivered:") : translate("shipment_tracking.estimated_delivery", "Estimated Delivery:")}</animate><br/>
        <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Loading...</animate>
      </div>
      <div className="shipment-summary__item text-center">
        <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">{translate("shipment_tracking.shipping_company", "Shipping Company:")}</animate><br/>
        <animate class="bg-lightest-grey rounded-lg text-transparent inline-block h-2" data-animation="pulse">Loading...</animate>
      </div>
    </div>;
  
    return skeleton;
  }

  let esimatedDeliveryLabel = translate("shipment_tracking.estimated_delivery", "Estimated Delivery:");
  let esimatedDelivery = "Unknown";
  if(shipment?.summary?.actual_delivery){
    esimatedDeliveryLabel = translate("shipment_tracking.actual_delivery", "Delivered:");
    esimatedDelivery = moment(shipment?.summary?.actual_delivery).format("M/DD/YY h:mma");
  }else if(shipment?.summary?.estimated_delivery){
    esimatedDelivery = moment(shipment?.summary.estimated_delivery).format("M/DD/YY");
  }

  return (
    <div className="shipment-summary container container--narrow my-10 flex justify-between gap-5">
      <div className="shipment-summary__item text-center">
        <span class="font-bold h6">{translate("shipment_tracking.picked_up", "Picked Up:")}</span><br/>
        <span class="font-light text-lg">{shipment?.summary?.pickup_date ? moment(shipment.summary?.pickup_date).format("M/DD/YY") : "Soon..."}</span> 
      </div>
      <div className="shipment-summary__item text-center">
        <span class="font-bold h6">{esimatedDeliveryLabel}</span><br/>
        <span class="font-light text-lg">{esimatedDelivery}</span> 
      </div>
      <div className="shipment-summary__item text-center">
        <span class="font-bold h6">{translate("shipment_tracking.shipping_company", "Shipping Company:")}</span><br/>
        <span class="font-light text-lg">{shipment.summary?.carrier_name}</span> 
      </div>
    </div>
  );

}

export default ShipmentSummary;